export default "__VITE_ASSET__3d09dd03__"